export default class API {
    static async submitForm(FORM_ID, formData, images) {
        const requestBodyWithFormId = JSON.stringify({
            formId: FORM_ID,
            formData: formData,
            images: images ? images : [],
        });

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: requestBodyWithFormId,
        };

        const response = await fetch("/api/collect/submit", requestOptions);

        return true;
    }

    static submitFormWithProgress(FORM_ID, formData, images, onProgress) {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open('POST', '/api/collect/submit');
            xhr.setRequestHeader('Content-Type', 'application/json');

            const body = JSON.stringify({ formId: FORM_ID, formData, images });

            xhr.upload.onprogress = (e) => {
                if (e.lengthComputable) {
                    onProgress(e.loaded, e.total);
                }
            };

            xhr.onload = () => resolve(true);
            xhr.onerror = () => reject(new Error('Upload failed'));

            xhr.send(body);
        });
    }

    static async loadReleaseData(vehicleLabel, type) {
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                vehicleLabel: vehicleLabel,
                type: type
            }),
        };

        return await fetch("/api/forms/releaseFormData", requestOptions);
    }

    static async loadAluminumTowerSentData(clientName) {
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ clientName: clientName }),
        };

        return await fetch("/api/forms/aluminumTowerSentData", requestOptions);
    }

    static async getMetricByCarId(carId, metricId) {
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                carId: carId,
                metricId: metricId,
            }),
        };

        // Create a timeout promise that rejects after 10 seconds
        const timeoutPromise = new Promise((_, reject) =>
            setTimeout(() => reject(new Error("Request timeout")), 10000)
        );

        try {
            const response = await Promise.race([
                fetch("/api/forms/getMetric", requestOptions),
                timeoutPromise,
            ]);

            if (!response.ok) {
                if (response.status === 204) {
                    return null; // No content - no metric found
                }
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            return await response.json();
        } catch (error) {
            console.error("Error fetching metric:", error);
            return null; // Return null on any error (timeout, network, etc.)
        }
    }

    static async getLightTechProductsByCarId(carId) {
        const requestOptions = {
            method: "GET"
        };

        return await fetch(
            `/api/collect/light-vehicle-products?rwNumber=${carId}`,
            requestOptions
        );
    }

    static async getAluminumTowerModels() {
        return await fetch('/api/collect/aluminum-tower-models').then(r => r.json());
    }

    static async getAluminumTowerComponents(modelId) {
        return await fetch(`/api/collect/aluminum-tower-components?modelId=${modelId}`).then(r => r.json());
    }

    static async getAllAluminumTowerComponents() {
        return await fetch('/api/collect/aluminum-tower-all-components').then(r => r.json());
    }
}
